<div class="new-claim-modal container">
  <div class="row">
    <div class="new-claim-modal__content new-claim-modal__content col-12">
      <div class="cx-dialog-header modal-header" style="height: 75px">
        <div class="cx-dialog-title modal-title">
          <div class="label-content">
            <p>{{ data.modalText }}</p>
            <!-- <p *ngIf="data.claimReason == 'SHORT_OVER_SUPPLIED'">Step 2 Complete the following to confirm the items you were over supplied.</p> -->
            <!-- <p *ngIf="data.claimReason == 'SHORT_SUPPLIED'">Thanks for confirming. You are now creating a second claim.</p> -->
            <div class="modelOs">
              <b>Were you invoiced for the oversupplied product?</b>
            </div>
          </div>
        </div>
        <button
          type="button"
          class="close"
          aria-label="Close"
          cxModal="dismiss"
          cxModalReason="Cross click"
          (click)="closeModal()"
        >
          <i class="fas fa-window-close"></i>
        </button>
      </div>
      <div class="cx-dialog-body modal-body" id="modellabel3">
        <div class="row">
          <div class="form-group">
            <div class="form-check">
              <input
                formControlName="accept"
                class="form-check-input"
                type="radio"
                value="true"
                id="defaultCheck2"
                (change)="changeclaim($event)"
              />
              <label class="form-check-label" for="defaultCheck2" id="modellabel">Yes</label>
            </div>
          </div>
          <div class="form-group" style="margin-left: 30px">
            <div class="form-check">
              <input
                formControlName="accepts"
                class="form-check-input"
                type="radio"
                value="false"
                id="defaultCheck3"
                (change)="changeclaim($event)"
              />
              <label class="form-check-label" for="defaultCheck3" id="modellabel">No</label>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
